import { useAuthContext } from '@providers/AuthProvider';
import { useLocation } from 'react-router-dom';
import { AdminMenu } from './components/AdminMenu';
import { Menu } from './components/Menu';
import { Welcome } from './components/Welcome';
import { WelcomeAdmin } from './components/WelcomeAdmin';

export const WelcomeAndMenu = () => {
  const location = useLocation();
  const { me } = useAuthContext();
  const isVsAdmin = me?.roles?.includes('ROLE_VS_ADMIN');
  const isVsAdminSection = location.pathname.startsWith('/admin/');

  if (isVsAdminSection && isVsAdmin) {
    return (
      <>
        <WelcomeAdmin />
        <div className="h-screen flex flex-col items-start w-full m-0">
          <AdminMenu />
        </div>
      </>
    );
  }
  return (
    <>
      <Welcome />
      <div className="h-screen flex flex-col items-start w-full m-0">
        <Menu />
      </div>
    </>
  );
};
